<template>
  <list-content
      v-bind:rows-data="tableData"
      v-bind:columns="tableColumns"
      v-bind:add-label="pageContent.add_label"
      v-bind:title="pageContent.title"
      v-bind:new-uri="pageContent.newUri"
      v-bind:edit-uri="pageContent.editUri"
      v-bind:meta="meta"
      v-bind:show-message="showMessage"
      v-bind:message="message"
      @handlePageChange="handleCurrentChange"
      @handleSizeChange="handleSizeChange"
      @handleSearchData="performSearch"
      @handleDeleteData="handleDelete"
  ></list-content>
</template>

<script>
import PriceService from "@/api/price.service";
import ListContent from "@/components/ProductContent";

export default {
  name: "Price",
  components: {ListContent},
  data() {
    return {
      tableColumns: [
          {'key':'name', 'label':'Product Name', 'sortable':true, 'is_image': false, 'width':''},
          {'key':'pricing.price', 'label':'Product Price', 'sortable':true, 'is_image': false, 'width':'250'},
           {'key':'pricing.currency', 'label':'Currency', 'sortable':true, 'is_image': false, 'width':'150'},
           {'key':'pricing.interval', 'label':'Interval', 'sortable':true, 'is_image': false, 'width':'150'}
      ],
      pageContent: {
        'add_label': 'Add Price',
        'title': 'Price',
        'newUri': '/price/add',        
        'editUri':'/price/edit'
      },
      tableData: [],
      page: 1,
      search: '',
      meta: Object,
      showMessage: false,
      message: {message:'', messageType:'success', effect:'dark'}
    }
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    async getTableData() {
      return PriceService.price(this.page, this.search).then(response => {
        this.meta = response.data.meta;
        this.tableData = response.data.data;
      });
    },
    performSearch(search) {
      this.search = search.name;
      this.getTableData();
    },
    handleDelete(data) {
      let deleteRow = data.row;
      this.showMessage = false;
      if (data.indexNo >= 0) {
        return PriceService.delete(deleteRow).then(response => {
          if(response.status === 201) {
            this.message.message = "Price deleted successfully";
            this.message.messageType = "success";
            this.message.effect = "dark";
            this.showMessage = true;
            this.getTableData();
          }
        });
      }
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getTableData();
    },
    handleSizeChange(val){
      this.getTableData();
    }
  }
}
</script>
<style lang="scss">
</style>
<style lang="scss" scoped>
</style>